import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import InputBase, { inputBaseClasses } from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Grid from '@mui/material/Grid';
import StopOverlayPropagation from '../StopOverlayPropagation/StopOverlayPropagation';
import { styled } from '@mui/material/styles';

const CreateModeRoot = styled(Grid, {
  shouldForwardProp: prop => prop !== 'isMultiSelectionMode'
})(({ theme, isMultiSelectionMode }) => ({
  padding: isMultiSelectionMode
    ? theme.spacing(0.5, 1.5, 0.5, 2.75)
    : theme.spacing(0.25, 1.5, 0.25, 1.875)
}));

const CreateModeInput = styled(InputBase)({
  flexGrow: 1,
  [`& .${inputBaseClasses.input}`]: {
    textOverflow: 'ellipsis'
  }
});

const CreateMode = ({
  placeholder,
  isMultiSelectionMode,
  onChange,
  onClose
}) => {
  const [value, setValue] = useState('');
  const inputEl = useRef(null);
  useEffect(() => {
    inputEl.current.focus();
  }, []);

  return (
    <StopOverlayPropagation>
      <CreateModeRoot
        container
        isMultiSelectionMode={isMultiSelectionMode}
        justifyContent="space-between"
        data-qa-id="create-item-container">
        <CreateModeInput
          value={value}
          inputRef={inputEl}
          placeholder={placeholder}
          onChange={event => setValue(event.target.value)}
          onKeyDown={event => {
            const { key } = event;
            if (key === 'Escape' || key === 'Esc') {
              onClose();
            }
            if (isEmpty(value)) {
              return;
            }
            if (key === 'Enter') {
              onChange(value);
              onClose();
            }
          }}
          inputProps={{
            'data-qa-id': 'create-item-input'
          }}
        />

        <div>
          <IconButton
            aria-label="close create new label"
            data-qa-id="cancel-button"
            onClick={() => {
              onClose();
            }}>
            <CloseOutlinedIcon fontSize="small" />
          </IconButton>
          <IconButton
            color="primary"
            data-qa-id="create-new-button"
            aria-label="create new label"
            disabled={isEmpty(value)}
            onClick={() => {
              onChange(value);
              onClose();
            }}>
            <CheckOutlinedIcon fontSize="small" />
          </IconButton>
        </div>
      </CreateModeRoot>
    </StopOverlayPropagation>
  );
};

CreateMode.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onClose: PropTypes.func
};

export default CreateMode;
